import { getImageUrl } from './getImageUrl';

export function getTopImage(image: {id?: string | undefined | null} | undefined | null) {
    return getImageUrl(image?.id, 1920, 750);
}
